import "clsx";
import { P as Pricing } from "../../../../../chunks/Pricing.js";
function _page($$payload) {
  Pricing($$payload);
}
export {
  _page as default
};
